export default [
    {
        kram: 1,
        title: "कलम",
        axar: "क",
        image: "bal_vibhag/paku_kariye/hindi-kakko/ka.png",
    },
    {
        kram: 2,
        title: "खटिया",
        axar: "ख",
        image: "bal_vibhag/paku_kariye/hindi-kakko/kha.png",
    },
    {
        kram: 3,
        title: "गदा",
        axar: "ग",
        image: "bal_vibhag/paku_kariye/hindi-kakko/ga.png",
    },
    {
        kram: 4,
        title: "घड़ियाल",
        axar: "घ",
        image: "bal_vibhag/paku_kariye/hindi-kakko/gha.png",
    },
    {
        kram: 5,
        title: "चरखा",
        axar: "च",
        image: "bal_vibhag/paku_kariye/hindi-kakko/cha.png",
    },
    {
        kram: 6,
        title: "छड़ी",
        axar: "छ",
        image: "bal_vibhag/paku_kariye/hindi-kakko/chha.png",
    },
    {
        kram: 7,
        title: "जलेबी",
        axar: "ज",
        image: "bal_vibhag/paku_kariye/hindi-kakko/ja.png",
    },
    {
        kram: 8,
        title: "झरना",
        axar: "झ",
        image: "bal_vibhag/paku_kariye/hindi-kakko/za.png",
    },
    {
        kram: 9,
        title: "टमाटर",
        axar: "ट",
        image: "bal_vibhag/paku_kariye/hindi-kakko/ta.png",
    },
    {
        kram: 10,
        title: "ठठेरा",
        axar: "ठ",
        image: "bal_vibhag/paku_kariye/hindi-kakko/tha.png",
    },
    {
        kram: 11,
        title: "डमरू",
        axar: "ड",
        image: "bal_vibhag/paku_kariye/hindi-kakko/da.png",
    },
    {
        kram: 12,
        title: "ढकन",
        axar: "ढ",
        image: "bal_vibhag/paku_kariye/hindi-kakko/dha.png",
    },
    {
        kram: 13,
        title: "बाण",
        axar: "ण",
        image: "bal_vibhag/paku_kariye/hindi-kakko/na.png",
    },
    {
        kram: 14,
        title: "तराजू ",
        axar: "त",
        image: "bal_vibhag/paku_kariye/hindi-kakko/ta-flat.png",
    },
    {
        kram: 15,
        title: "थन",
        axar: "थ",
        image: "bal_vibhag/paku_kariye/hindi-kakko/tha-flat.png",
    },
    {
        kram: 16,
        title: "दवात",
        axar: "द",
        image: "bal_vibhag/paku_kariye/hindi-kakko/da-flat.png",
    },
    {
        kram: 17,
        title: "धनुष",
        axar: "ध",
        image: "bal_vibhag/paku_kariye/hindi-kakko/dha-flat.png",
    },
    {
        kram: 18,
        title: "नल",
        axar: "न",
        image: "bal_vibhag/paku_kariye/hindi-kakko/na-flat.png",
    },
    {
        kram: 19,
        title: "पतंग",
        axar: "प",
        image: "bal_vibhag/paku_kariye/hindi-kakko/pa.png",
    },
    {
        kram: 20,
        title: "फव्वारा",
        axar: "फ",
        image: "bal_vibhag/paku_kariye/hindi-kakko/fa.png",
    },
    {
        kram: 21,
        title: "बतख",
        axar: "ब",
        image: "bal_vibhag/paku_kariye/hindi-kakko/ba.png",
    },
    {
        kram: 22,
        title: "भरनी",
        axar: "भ",
        image: "bal_vibhag/paku_kariye/hindi-kakko/bha.png",
    },
    {
        kram: 23,
        title: "मछली",
        axar: "म",
        image: "bal_vibhag/paku_kariye/hindi-kakko/ma.png",
    },
    {
        kram: 24,
        title: "यज्ञ",
        axar: "य",
        image: "bal_vibhag/paku_kariye/hindi-kakko/ya.png",
    },
    {
        kram: 25,
        title: "रथ",
        axar: "र",
        image: "bal_vibhag/paku_kariye/hindi-kakko/ra.png",
    },
    {
        kram: 26,
        title: "लट्टू",
        axar: "ल",
        image: "bal_vibhag/paku_kariye/hindi-kakko/la.png",
    },
    {
        kram: 27,
        title: "वजन",
        axar: "व",
        image: "bal_vibhag/paku_kariye/hindi-kakko/va.png",
    },
    {
        kram: 28,
        title: "शलगम",
        axar: "श",
        image: "bal_vibhag/paku_kariye/hindi-kakko/sha.png",
    },
    {
        kram: 29,
        title: "षट्कोण",
        axar: "ष",
        image: "bal_vibhag/paku_kariye/hindi-kakko/sha-flat.png",
    },
    {
        kram: 30,
        title: "सरौता",
        axar: "स",
        image: "bal_vibhag/paku_kariye/hindi-kakko/sa.png",
    },
    {
        kram: 31,
        title: "हथौड़ी",
        axar: "ह",
        image: "bal_vibhag/paku_kariye/hindi-kakko/ha.png",
    },
    {
        kram: 32,
        title: "टिळक",
        axar: "ळ",
        image: "bal_vibhag/paku_kariye/hindi-kakko/kha.png",
    },
    {
        kram: 33,
        title: "क्षत्रिय",
        axar: "क्ष",
        image: "bal_vibhag/paku_kariye/hindi-kakko/ksha.png",
    },
    {
        kram: 34,
        title: "ज्ञानी",
        axar: "ज्ञ",
        image: "bal_vibhag/paku_kariye/hindi-kakko/gna.png",
    },
];
